import React from 'react'
import  LayoutComp  from '../../../layout/LayoutComp'
import CasinoComp from '../../../components/promotions/viewall/category/CasinoComp'

const Casino = () => {
    return (
        <LayoutComp>
            <CasinoComp />
        </LayoutComp>
    )
}

export default Casino